import { Resource } from './Resource';
import { ResourcePool } from './ResourcePool';
import { IMediaContainer } from './IMediaContainer';

export abstract class ResourcePoolImpl<
  ResourceType extends Resource<DataType>,
  DataType,
> extends ResourcePool<ResourceType> {
  abstract loadData(data: string): DataType;

  public get requiresMediaContainer(): boolean {
    return false;
  }

  loadResourceData(
    resource: ResourceType,
    xml: HTMLElement,
    _: IMediaContainer | null
  ): Promise<void> {
    const result = this.loadData(xml.textContent!);
    resource.construct(result);
    return Promise.resolve();
  }
}
